module.exports = __webpack_public_path__ + "89f9071515c41c4ae3193906aee48c2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/images/ens-logo.png
// module id = 373
// module chunks = 1